module.exports = __webpack_public_path__ + "static/media/up-arrow-green.16f6c015.svg";